import React from 'react';
import ReactDOM, { render } from 'react-dom';
import BaseComponent from 'foundation/base-component';
import eventBus from 'general/js/event-bus';
import app, { EVENT_DEVICE_TYPE_CHANGED } from 'general/js/app';
import { CONTROL_TYPE_CHECKLIST } from '../../listing/js/constants';
import { getPattern } from './patterns';
import NewsFeedLayout from './news-feed-layout';


class NewsFeedComponent extends BaseComponent {
    constructor(...args) {
        super(...args);

        this.data = this.getData();

        if (!this.data) {
            throw new Error('Invalid JSON initial data');
        }

        const endpointUrl = this.data.endpointUrl;

        if (!endpointUrl) {
            throw new Error('EndpointUrl should be passed via options');
        }

        const filters = this.data.filters.map((filter) => (
            {
                type: CONTROL_TYPE_CHECKLIST,
                name: filter.name,
                options: filter.values,
                defaultValue: []
            }
        ));

        this.listingOptions = {
            endpointUrl,
            filters,
            initialItems: this.data.articles,
            pagination: this.data.pagination,
            customParams: this.data.data
        };

        this.init();
    }

    static getRequiredRefs() {
        return ['filters', 'listing'];
    }

    init() {
        this.renderSection();

        eventBus.addListener(EVENT_DEVICE_TYPE_CHANGED, this.onChangeDeviceType);
    }

    getData() {
        let data = null;

        try {
            data = JSON.parse(this.getAttribute(this.refs.data, 'json'));
        } catch (error) {
            console.log(error);
        }

        return data;
    }

    onFiltersDirtyChange = (isDirty) => {
        if (!Array.isArray(this.refs.components)) return;

        this.refs.components.forEach((component) => {
            component.hidden = isDirty;
        });
    }

    onChangeDeviceType = () => {
        this.renderSection();
    }

    renderSection() {
        render(
            <NewsFeedLayout
                options={this.listingOptions}
                pattern={this.getPattern()}
                translations={this.data.translations}
                banner={this.data.banner}
                patternSize={this.data.patternSize}
                filtersNode={this.refs.filters}
                placeholderNode={this.refs.placeholder}
                onFiltersDirtyChange={this.onFiltersDirtyChange}
            />,
            this.refs.listing
        );
    }

    getPattern() {
        return getPattern(app.deviceTypeByViewport);
    }

    onDestroy() {
        ReactDOM.unmountComponentAtNode(this.refs.listing);
    }
}

export default NewsFeedComponent;
